/**
 * Created by Tima on 2019/1/17.
 */
window.onerror = function (err) {
  console.log('window.onerror: ' + err)
}

// <!-- 申明交互 -->
function setupWebViewJavascriptBridge (callback) {
  if (window.WebViewJavascriptBridge) {
    callback(WebViewJavascriptBridge)
  } else {
    document.addEventListener(
      'WebViewJavascriptBridgeReady'
      , function () {
        callback(WebViewJavascriptBridge)
      },
      false
    )
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback)
  }
  
  if (urlParse('source') == "app") {
    // 创建一个 WVJBCallbacks 全局属性数组，并将 callback 插入到数组中。
    window.WVJBCallbacks = [callback]
    // 创建一个 iframe 元素
    let WVJBIframe = document.createElement('iframe')
    // 不显示
    WVJBIframe.style.display = 'none'
    // 设置 iframe 的 src 属性
    WVJBIframe.src = 'https://__bridge_loaded__'
    console.log('https://__bridge_loaded__')
    // 把 iframe 添加到当前文导航上。
    document.documentElement.appendChild(WVJBIframe)
    setTimeout(function () {
      document.documentElement.removeChild(WVJBIframe)
    }, 0)
  }
}

// 判断是否是app调用
function urlParse (variable) {
  let query = window.location.search.substring(1);
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1]
    }
  }
  return false;
}

// 注册回调函数，第一次连接时调用 初始化函数
// bridge.init 只有android需要调用初始化，可以使用Object.keys(bridge) 打开查看对象，ios没有init方法
console.log(urlParse('source'));
if (urlParse('source') == "app") {
  setupWebViewJavascriptBridge(function (bridge) {
    try {
      if (bridge.init) {
        bridge.init(function (message, responseCallback) {
          console.log('JS got a message', message)
          var data = {
            'Javascript Responds': 'CMYH!'
          }
          console.log('JS responding with', data)
          responseCallback(data)
        })
      }
    } catch (e) {
      console.log(e)
    }
  })
}
const appFunction = {
  //需要登录
  JS2APP_login: (params, functionCallback) => {
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_login', params, function (response) {
          })
          bridge.registerHandler('APP2JS_setUserInfo', function (response) {
            
            localStorage.setItem('user-token', JSON.parse(response).token)
            localStorage.setItem('user-aid', JSON.parse(response).aid)
            functionCallback(JSON.parse(response).token)
          })
      })
    }
  },
  // 获取版本
  JS2APP_getAppVersion: (params, functionCallback) => {
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
        
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_getAppVersion',params, function (response) {
            functionCallback(JSON.parse(response))
          })
          bridge.registerHandler('JS2APP_getAppVersion', function (response) {
            console.log('2')
            functionCallback(JSON.parse(response))
          })
      })
    }
  },
  //活动回顾
  JS2APP_activityReview: (params) => {
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
        
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_activityReview',params, function (response) {})
      })
    }
  },
  //邀请好友
  JS2APP_inviteFriend: (params) => {
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_inviteFriend',params, function (response) {})
      })
    }
  },
  //回到app
  JS2APP_backHomePage: () => {
    console.log('调用方法')
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
        
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_backHomePage',{}, function (response) {})
      })
    }
  },
  //跳转到抽奖页
  JS2APP_pushDrawView: () => {
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
        
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_pushDrawView',{}, function (response) {})
      })
    }
  },
  //反馈
  JS2APP_feedback: () => {
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
        
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_feedback',{}, function (response) {})
      })
    }
  },
  JS2APP_launchMiniProgram(){
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
        
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_launchMiniProgram',{}, function (response) {})
      })
    }
  },
  JS2APP_selectPoi: (params, functionCallback) => {
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
        
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_selectPoi',params, function (response) {})
          bridge.registerHandler('APP2JS_selectPoi', function (response) {
            functionCallback(response)
          })
      })
    }
  },
  JS2APP_getUser: (params, functionCallback) => {
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_getUser',params, function (response) {
            functionCallback(response)
          })

      })
    }
  },
  JS2APP_selectDriveShop: (params, functionCallback) => {
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
        
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_selectDriveShop',params, function (response) {})
          bridge.registerHandler('APP2JS_selectDriveShop', function (response) {
            functionCallback(response)
          })
      })
    }
  },
  JS2APP_getLocation: (params, functionCallback) => {
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_getLocation',params, function (response) {
            functionCallback(response)
          })

      })
    }
  },
  JS2APP_saveWishSuccess: (params, functionCallback) => {
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_saveWishSuccess',params, function (response) {
            functionCallback(response)
          })
          

      })
    }
  },
  JS2APP_closeWeb: (params, functionCallback) => {
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_closeWeb',params, function (response) {
            functionCallback(response)
          })
          bridge.registerHandler('JS2APP_closeWeb', function (response) {
            functionCallback(response)
          })
      })
    }
  },
  JS2APP_launchMiniProgram_bc: (params, functionCallback) => {
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_launchMiniProgram_bc',params, function (response) {
            functionCallback(response)
          })

      })
    }
  },
  JS2APP_gioTrack(params, functionCallback){
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_gioTrack',params, function (response) {
            functionCallback(response)
          })
      })
    }
  },
  JS2APP_carGuessPage(params, functionCallback){
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_carGuessPage',params, function (response) {
            functionCallback(response)
          })
      })
    }
  },
  JS2APP_carOrderPay(params, functionCallback){
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_carOrderPay',params, function (response) {
            functionCallback(response)
          })
      })
    }
  },
  JS2APP_maintenanceAppointment(params, functionCallback){
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_maintenanceAppointment',params, function (response) {
            functionCallback(response)
          })
      })
    }
  },
  JS2APP_navigate(params, functionCallback){
    if (urlParse('source') == "app") {
      setupWebViewJavascriptBridge(function (bridge) {
          //  <!--处理 oc 调用 js -->
          bridge.callHandler('JS2APP_navigate',params, function (response) {
            functionCallback(response)
          })
      })
    }
  },
}


export default appFunction
